if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.#mount();
		}

		#mount(){

			/* -- > DRAWERS < -- */

			// Sticky header

			if ( this.hasAttribute('data-sticky-header') ) {

				const headerTop = this.querySelector('.header__top');
				const headerBottom = this.querySelector('.header__bottom');
				const headerLayout = this.getAttribute('data-header-layout') || 'stacked';
				const stickyHeader = document.createElement('div');
				stickyHeader.classList = 'sticky-header'
				stickyHeader.setAttribute('data-js-inert', '');
				if ( headerLayout === 'inline' || ! headerBottom ) {
					stickyHeader.classList.add('sticky-header--inline');
					stickyHeader.innerHTML = `<div class="site-header site-header--inline">
						<div class="header-container">
							<div class="header__top container--large">
								${headerTop.innerHTML}
							</div>
						</div>
					</div>`;
				} else {
					stickyHeader.innerHTML = `<div class="header__bottom header-container container--large portable-hide">
						${headerBottom.innerHTML}
					</div>
					<div class="site-header header__top container--large">
						${headerTop.innerHTML}
					</div>`;
				}
				document.body.append(stickyHeader);
				this._stickyHeaderEl = stickyHeader;

				if ( headerLayout !== 'inline' && this.querySelector('.button--cart-handle') && stickyHeader.querySelector('.header-actions') ) {
					stickyHeader.querySelector('.header-actions').append(this.querySelector('.button--cart-handle').cloneNode(true));
				}

				stickyHeader.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-sticky`;
				})
				stickyHeader.querySelectorAll('[data-js-focus-overlay]').forEach(elm=>{
					const ref = elm.getAttribute('data-js-focus-overlay');
					if ( ref ) {
						elm.setAttribute('data-js-focus-overlay', `${ref}-sticky`);
					}
				})
				stickyHeader.querySelectorAll('[aria-controls]').forEach(elm=>{
					if ( ! ( elm.hasAttribute('data-js-sidebar-handle') || elm.hasAttribute('data-modal') ) ) {
						elm.setAttribute('aria-controls', `${elm.getAttribute('aria-controls')}-sticky`);
					}
				})

				window.lst = window.scrollY;
				window.lhp = 0;

				const stickyHeaderDeskBound = headerBottom || headerTop;
				const stickyHeaderMobileBound = headerTop;

				const stickyHeaderMayRemoveShowOnScrollDown = ()=>{
					return ! this._headerMobileSearchExpanded;
				};

				this.SCROLL_StickyHelper = () =>{
					
					var st = window.scrollY;
					try {
						if ( ( st <= 0 || ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top >= 0 : stickyHeaderMobileBound.getBoundingClientRect().top >= 0 ) ) && stickyHeader.classList.contains('show') ) {
							stickyHeader.classList.remove('show');
							return;
						}

						if ( st < 0 || Math.abs(lst - st) <= 5 )
							return;	

						if ( st > window.lhp ) {

							if ( st === 0 && stickyHeader.classList.contains('show') ) {

								stickyHeader.classList.remove('show');

							} else if ( st <= lst && ! stickyHeader.classList.contains('show') ) {

								window.lhp = stickyHeader.offsetTop;
								if ( ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top : stickyHeaderMobileBound.getBoundingClientRect().top ) < -100 ) {
									stickyHeader.classList.add('show');
								}

							} else if ( st > lst && stickyHeader.classList.contains('show') ) {
								if ( stickyHeaderMayRemoveShowOnScrollDown() ) {
									stickyHeader.classList.remove('show');
								}
							}

						}
					} finally {
						window.lst = st;
					}

				}

				window.addEventListener('scroll', this.SCROLL_StickyHelper, {passive:true});

					stickyHeader.querySelectorAll('.submenu-masonry').forEach(elm=>{
						let columns = 4;
						if ( elm.classList.contains('with-2-promotions') ) {
							columns = 2;
						} else if ( elm.classList.contains('with-promotion') ) {
							columns = 3;
						}
						if ( elm.dataset.columns ) {
							columns = parseInt(elm.dataset.columns);
						}
						const trigger = elm.closest('.has-submenu');
						if ( ! trigger ) return;
						// Build MiniMasonry on first open (relayout on later opens) inside rAF, once
						// the menu is visible — measuring a hidden menu produced inconsistent gaps.
						let masonry = null;
						const layoutMasonry = () => requestAnimationFrame(() => {
							if ( typeof MiniMasonry === 'undefined' ) return;
							const width = elm.clientWidth;
							if ( ! width ) return;
							if ( masonry ) masonry.destroy();
							elm.classList.add('masonry-active');
							masonry = new MiniMasonry({
								container: elm,
								baseWidth: Math.floor(width / columns),
								gutter: 0,
								surroundingGutter: false,
								direction: document.documentElement.getAttribute('dir') === 'rtl' ? 'rtl' : 'ltr'
							});
							elm.querySelectorAll('img').forEach(img => {
								if ( ! img.complete ) {
									img.addEventListener('load', () => { if ( masonry ) masonry.layout(); }, { once: true });
								}
							});
						});
						trigger.addEventListener('mouseenter', layoutMasonry);
						trigger.addEventListener('focusin', layoutMasonry);
					});
				
			} else {
				this._stickyHeaderEl = null;
			}

			// drawer cart connections

			document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
					elm.addEventListener('click', e=>{
						e.preventDefault();
						elm.setAttribute('aria-expanded', 'true');
						elmSidebar.show();
					})
					elm.addEventListener('keyup', e=>{
						if ( e.keyCode === window.KEYCODES.RETURN ) {
							elm.setAttribute('aria-expanded', 'true');
							elmSidebar.show();
							window.lastFocusedElm = elm;
							elmSidebar.querySelector('[data-js-close]').focus();
						}
					})
				}
			})
			
			// closing drawers

			document.querySelectorAll('sidebar-drawer [data-js-close]').forEach(elm=>{
				elm.addEventListener('keydown', e=>{
					if ( e.keyCode === window.KEYCODES.RETURN ) {
						if ( window.lastFocusedElm ) {
							setTimeout(()=>{
								window.lastFocusedElm.focus();
								window.lastFocusedElm = null;
							}, 100);
						}
					}
				});
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( e.target.closest('.sidebar').classList.contains('sidebar--opened') ) {
						e.target.closest('.sidebar').hide();
					}
				});
			});
			document.querySelector('.site-overlay').addEventListener('click', ()=>{
				if ( document.querySelector('.sidebar--opened') ) {
					document.querySelector('.sidebar--opened').hide();
				}
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode === window.KEYCODES.ESC ) {
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
						if ( window.lastFocusedElm ) {
							window.lastFocusedElm.focus();
							window.lastFocusedElm = null;
						}
					}
				}
			});

			// resizing drawers

			const rootHeight = document.getElementById('root-height');
			this.RESIZE_SidebarHelper = debounce(()=>{
				rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
				}`;
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
			}`;

			// Inert elements

			document.querySelectorAll('#main > div').forEach(elm=>{
				if ( ! elm.classList.contains('inert-inside') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			window.inertElems = document.querySelectorAll('[data-js-inert]');

			// Init modal windows

			document.querySelectorAll('[aria-controls="modal-store-selector"]').forEach(elm=>{
				elm.addEventListener('keydown', e=>{
					if ( e.keyCode === window.KEYCODES.RETURN ) {
						window.lastFocusedElm = elm;
					}
				})
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
					if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
						document.getElementById(elm.getAttribute('aria-controls')).show();
					}
				})
				elm.addEventListener('keyup', e=>{
					if ( e.keyCode === window.KEYCODES.RETURN ) {
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					}
				})
			});

			// Submenu alignment — left is relative to the absolute containing block,
			// not the viewport (centered .container--large on large screens).
			const rtl = document.documentElement.getAttribute('dir') === 'rtl';
			const alignNormalMenu = (elm)=>{
				const submenu = elm.querySelector(':scope > .normal-menu');
				if ( ! submenu ) {
					return;
				}
				const containing = submenu.offsetParent;
				if ( ! containing ) {
					return;
				}
				const itemRect = elm.getBoundingClientRect();
				const containingRect = containing.getBoundingClientRect();
				const left = rtl ? itemRect.right - containingRect.left : itemRect.left - containingRect.left;
				submenu.style.left = `${left}px`;
			};
			document.querySelectorAll('.site-nav.style--classic .has-submenu').forEach(elm=>{
				if ( ! elm.querySelector(':scope > .normal-menu') ) {
					return;
				}
				elm.addEventListener('mouseenter', ()=> alignNormalMenu(elm));
				elm.addEventListener('focusin', ()=> alignNormalMenu(elm));
				elm.addEventListener('touchstart', ()=> alignNormalMenu(elm), { passive: true });
			});
			document.querySelectorAll('scrollable-navigation').forEach(nav=>{
				nav.addEventListener('scroll', ()=>{
					nav.querySelectorAll('.site-nav.style--classic .has-submenu').forEach(elm=>{
						if ( elm.matches(':hover') || elm.classList.contains('focus') ) {
							alignNormalMenu(elm);
						}
					});
				}, { passive: true });
			});

			// predictive search

			const desktopSearchRoot = elm=>{
				return elm.closest('.sticky-header') || elm.closest('#site-header');
			};

			const closeDesktopSearch = root=>{
				if ( ! root ) {
					return;
				}
				const toggle = root.querySelector('[data-header-search-toggle]');
				const panel = root.querySelector('[data-header-desktop-search-panel]');
				if ( toggle ) {
					toggle.setAttribute('aria-expanded', 'false');
				}
				if ( panel ) {
					panel.classList.remove('is-open');
					panel.hidden = true;
					const overlay = panel.querySelector('.search-results-overlay');
					if ( overlay ) {
						overlay.classList.remove('active');
					}
				}
			};

			const openDesktopSearch = root=>{
				if ( ! root ) {
					return;
				}
				document.querySelectorAll('#site-header, .sticky-header').forEach(other=>{
					if ( other !== root ) {
						closeDesktopSearch(other);
					}
				});
				const toggle = root.querySelector('[data-header-search-toggle]');
				const panel = root.querySelector('[data-header-desktop-search-panel]');
				if ( ! toggle || ! panel ) {
					return;
				}
				panel.hidden = false;
				panel.classList.add('is-open');
				toggle.setAttribute('aria-expanded', 'true');
				const overlay = panel.querySelector('.search-results-overlay');
				if ( overlay ) {
					overlay.classList.remove('active');
				}
				const input = panel.querySelector('[data-js-search-input]');
				if ( input ) {
					input.focus();
				}
			};

			const bindPredictiveSearchInputListeners = elm=>{
				if ( ! elm ) {
					return;
				}
				elm.addEventListener('focus', ()=>{
					if ( ! elm.closest('[data-header-desktop-search-panel]') ) {
						const overlay = document.getElementById(elm.dataset.jsFocusOverlay);
						if ( overlay ) {
							overlay.classList.add('active');
						}
					}
					if ( ! document.body.classList.contains('predictive-script-loaded') ) {
						document.body.classList.add('predictive-script-loaded')
						const predictiveSearchJS = document.createElement('script');
						predictiveSearchJS.src = KROWN.settings.predictive_search_script;
						document.head.appendChild(predictiveSearchJS); 
					}
				})
				elm.addEventListener('keydown', e=>{
					if ( e.keyCode === window.KEYCODES.TAB ) {
						const panel = elm.closest('[data-header-desktop-search-panel]');
						if ( panel && panel.classList.contains('is-open') ) {
							if ( e.shiftKey ) {
								closeDesktopSearch(desktopSearchRoot(elm));
							}
							return;
						}
						const desktopOverlay = document.getElementById('search-results-overlay-desktop');
						if ( desktopOverlay && desktopOverlay.classList.contains('active') ) {
							desktopOverlay.classList.remove('active');
						}
					}
				})
			};

			document.querySelectorAll('[data-header-desktop-search-panel]').forEach(panel=>{
				panel.addEventListener('focusout', ()=>{
					window.requestAnimationFrame(()=>{
						if ( ! panel.classList.contains('is-open') ) {
							return;
						}
						const active = document.activeElement;
						if ( panel.contains(active) || ( active && active.closest('[data-header-search-toggle]') ) ) {
							return;
						}
						closeDesktopSearch(desktopSearchRoot(panel));
					});
				});
			});

			document.querySelectorAll('[data-header-search-toggle]').forEach(btn=>{
				btn.addEventListener('click', e=>{
					e.preventDefault();
					const root = desktopSearchRoot(btn);
					if ( btn.getAttribute('aria-expanded') === 'true' ) {
						closeDesktopSearch(root);
					} else {
						openDesktopSearch(root);
					}
				});
			});
			document.querySelectorAll('[data-header-desktop-search-panel] .search-results-overlay').forEach(overlay=>{
				overlay.addEventListener('click', ()=>{
					closeDesktopSearch(desktopSearchRoot(overlay));
				});
			});
			document.addEventListener('click', e=>{
				if ( e.target.closest('[data-header-search-toggle]') ) {
					return;
				}
				document.querySelectorAll('#site-header, .sticky-header').forEach(root=>{
					const panel = root.querySelector('[data-header-desktop-search-panel]');
					if ( ! panel || ! panel.classList.contains('is-open') || panel.contains(e.target) ) {
						return;
					}
					closeDesktopSearch(root);
				});
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode !== window.KEYCODES.ESC ) {
					return;
				}
				document.querySelectorAll('#site-header, .sticky-header').forEach(root=>{
					const panel = root.querySelector('[data-header-desktop-search-panel]');
					if ( panel && panel.classList.contains('is-open') ) {
						closeDesktopSearch(root);
					}
				});
			});

			if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {
				document.querySelectorAll('search-form [data-js-search-input]').forEach(bindPredictiveSearchInputListeners)
				window.addEventListener('load', ()=>{
					document.querySelectorAll('.search-results-overlay').forEach(elm=>{
						elm.style = '';
					})
				});
			} else {
				document.querySelector('search-form [data-js-search-input] + button').classList.add('button--invisibile-trigger');
			}

			// mobile search: toggle the full-width panel (independent per header)

			const mobileSearchSource = this.querySelector('[data-header-mobile-search-panel]');
			const mobileSearchToggles = document.querySelectorAll('[data-header-mobile-search-toggle]');
			this._headerMobileSearchExpanded = false;
			if ( mobileSearchSource && mobileSearchToggles.length && mobileSearchSource.classList.contains('mobile-search--compact') ) {

				const syncMobileSearchExpanded = ()=>{
					const stickyPanel = this._stickyHeaderEl && this._stickyHeaderEl.querySelector('[data-header-mobile-search-panel]');
					this._headerMobileSearchExpanded = mobileSearchSource.classList.contains('is-open') || Boolean(stickyPanel && stickyPanel.classList.contains('is-open'));
				};

				const setMobileSearchExpanded = (root, expanded)=>{
					root.querySelectorAll('[data-header-mobile-search-toggle]').forEach(btn=>{
						btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
					});
				};

				const prepareStickyMobileSearch = ()=>{
					if ( ! this._stickyHeaderEl ) {
						return null;
					}
					let panel = this._stickyHeaderEl.querySelector('[data-header-mobile-search-panel]');
					if ( panel ) {
						return panel;
					}
					panel = mobileSearchSource.cloneNode(true);
					panel.classList.add('hide');
					panel.classList.remove('is-open');
					panel.setAttribute('data-header-mobile-search-clone', '');
					this._stickyHeaderEl.appendChild(panel);
					panel.querySelectorAll('[id]').forEach(elm=>{
						elm.id = `${elm.id}-sticky`;
					});
					panel.querySelectorAll('[data-js-focus-overlay]').forEach(elm=>{
						const ref = elm.getAttribute('data-js-focus-overlay');
						if ( ref ) {
							elm.setAttribute('data-js-focus-overlay', `${ref}-sticky`);
						}
					});
					if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {
						bindPredictiveSearchInputListeners(panel.querySelector('[data-js-search-input]'));
					}
					return panel;
				};

				const closeMobileSearch = root=>{
					if ( ! root ) {
						return;
					}
					const panel = root.querySelector('[data-header-mobile-search-panel]');
					if ( panel ) {
						panel.classList.remove('is-open');
						panel.classList.add('hide');
						const overlay = panel.querySelector('.search-results-overlay');
						if ( overlay ) {
							overlay.classList.remove('active');
						}
					}
					setMobileSearchExpanded(root, false);
					syncMobileSearchExpanded();
				};

				const openMobileSearch = root=>{
					if ( ! root ) {
						return;
					}
					document.querySelectorAll('#site-header, .sticky-header').forEach(other=>{
						if ( other !== root ) {
							closeMobileSearch(other);
						}
					});
					const panel = root.classList.contains('sticky-header') ? prepareStickyMobileSearch() : root.querySelector('[data-header-mobile-search-panel]');
					if ( ! panel ) {
						return;
					}
					panel.classList.remove('hide');
					panel.classList.add('is-open');
					const overlay = panel.querySelector('.search-results-overlay');
					if ( overlay ) {
						overlay.classList.remove('active');
					}
					setMobileSearchExpanded(root, true);
					syncMobileSearchExpanded();
					const input = panel.querySelector('[data-js-search-input]');
					if ( input ) {
						input.focus();
					}
				};

				mobileSearchToggles.forEach(btn=>{
					btn.addEventListener('click', e=>{
						e.preventDefault();
						const root = btn.closest('.sticky-header') || btn.closest('#site-header');
						if ( btn.getAttribute('aria-expanded') === 'true' ) {
							closeMobileSearch(root);
						} else {
							openMobileSearch(root);
						}
					});
				});

				document.addEventListener('click', e=>{
					if ( e.target.closest('[data-header-mobile-search-toggle]') ) {
						return;
					}
					document.querySelectorAll('#site-header, .sticky-header').forEach(root=>{
						const panel = root.querySelector('[data-header-mobile-search-panel]');
						if ( ! panel || ! panel.classList.contains('is-open') || panel.contains(e.target) ) {
							return;
						}
						closeMobileSearch(root);
					});
				});

				document.addEventListener('keydown', e=>{
					if ( e.keyCode !== window.KEYCODES.ESC ) {
						return;
					}
					document.querySelectorAll('#site-header, .sticky-header').forEach(root=>{
						const panel = root.querySelector('[data-header-mobile-search-panel]');
						if ( panel && panel.classList.contains('is-open') ) {
							closeMobileSearch(root);
						}
					});
				});
			}

			this._headerSearchQNameSync = e=>{
				if ( e.target.tagName !== 'INPUT' || e.target.name !== 'q' ) {
					return;
				}
				if ( ! e.target.closest('#site-header') && ! e.target.closest('.sticky-header') ) {
					return;
				}
				const enterCode = window.KEYCODES ? window.KEYCODES.RETURN : 13;
				const enterInit = { key: 'Enter', code: 'Enter', keyCode: enterCode, which: enterCode, bubbles: true, cancelable: true };
				document.querySelectorAll('#site-header input[name="q"], .sticky-header input[name="q"]').forEach(el=>{
					if ( el !== e.target ) {
						el.value = '';
						el.dispatchEvent(new KeyboardEvent('keydown', enterInit));
						el.dispatchEvent(new KeyboardEvent('keyup', enterInit));
					}
				});
			};
			document.body.addEventListener('input', this._headerSearchQNameSync);

			// touch navigation for the menu

			const closeTouchSubmenus = (focusedElm, focusedParent=null)=>{
				document.querySelectorAll('.style--classic li.focus').forEach(elm=>{
					if ( ! ( elm === focusedElm || elm === focusedParent ) ) {
						elm.classList.remove('focus');
					}
				})
			}
			let babyMenuTouch = false;
			document.querySelectorAll('.style--classic .has-babymenu').forEach(elm=>{
				elm.addEventListener('touchstart', ()=>{
					elm.firstElementChild.style.pointerEvents = 'none';
					elm.classList.toggle('focus');
					babyMenuTouch = true;
					closeTouchSubmenus(elm,elm.closest('.has-submenu'));
				}, { passive:true });
			})
			document.querySelectorAll('.style--classic .has-submenu').forEach(elm=>{
				if ( ! elm.classList.contains('mega-link') ) {
					elm.addEventListener('touchstart', ()=>{
						elm.firstElementChild.style.pointerEvents = 'none';
						if ( ! babyMenuTouch ) {
							elm.classList.toggle('focus');
							closeTouchSubmenus(elm);
						}
						babyMenuTouch = false;
					}, { passive:true });
				}
			})

			// tab navigation for the menu

			document.querySelectorAll('.site-nav.style--classic .has-submenu > a').forEach(childEl=>{

				const elm = childEl.parentNode;
				const elmMenu = document.getElementById(childEl.getAttribute('aria-controls'));

				elm.addEventListener('keydown', e=>{

					if ( e.keyCode === window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							e.target.setAttribute('aria-expanded', 'true');
							//elmMenu.setAttribute('aria-hidden', 'false');
						} else if ( document.activeElement.parentNode.classList.contains('has-submenu') && elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							e.target.setAttribute('aria-expanded', 'true');
							//elmMenu.setAttribute('aria-hidden', 'false');
						}
					}
				});	
				
				if ( elm.querySelector('.submenu-holder > li:last-child a') ) {
					elm.querySelector('.submenu-holder > li:last-child a').addEventListener('focusout', e=>{
						if ( elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							e.target.setAttribute('aria-expanded', 'false');
							//elmMenu.setAttribute('aria-hidden', 'true');
						}
					});
				}

			});

			document.querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a').forEach(childEl=>{	

				const elm = childEl.parentNode;
				const elmMenu = document.getElementById(childEl.dataset.ariaControls);

				elm.addEventListener('keydown', e=>{
					if ( e.keyCode === window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							e.target.setAttribute('aria-expanded', 'true');
							//elmMenu.setAttribute('aria-hidden', 'false');
						} else {
							elm.classList.remove('focus');
							e.target.setAttribute('aria-expanded', 'false');
							//elmMenu.setAttribute('aria-hidden', 'true');
						}
					}
				});

				if ( elm.querySelector('.babymenu li:last-child a') ) {
					elm.querySelector('.babymenu li:last-child a').addEventListener('focusout', e=>{
						if ( elm.parentNode.classList.contains('focus') ) {
							elm.parentNode.classList.remove('focus');
							elm.parentNode.setAttribute('aria-expanded', 'false');
						}
					});
				}

			})

		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
			if ( this._headerSearchQNameSync ) {
				document.body.removeEventListener('input', this._headerSearchQNameSync);
			}
		}

	}
	
  if ( typeof customElements.get('main-header') === 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			this.querySelector('[data-js-close]').addEventListener('click', ()=>{
				this.hide();
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode === window.KEYCODES.ESC ) {
					const openedSidebar = document.querySelector('sidebar-drawer.sidebar--opened');
					if ( openedSidebar ){
						openedSidebar.hide();
					}
				}
			});
		}

		/* 
			* generic hide/show functions 
		*/

		show(){

			if ( this.classList.contains('product-size-guide-drawer') && this.parentElement !== document.body ) {
				document.body.appendChild(this);
			}
			if ( this.classList.contains('product-size-guide-drawer') ) {
				this.removeAttribute('inert');
			}

			this.opened = true;
			this.removeAttribute('aria-hidden');
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			this.style.display = 'grid';
			if ( this.classList.contains('product-size-guide-drawer') ) {
				this.dispatchEvent(new CustomEvent('size-guide:opened', { bubbles: true }));
			}
			setTimeout(()=>{
				this.classList.add('sidebar--opened');
				window.inertElems.forEach(elm=>{
					elm.setAttribute('inert', '');
				})
			}, 15);
			if ( this.id === "site-cart-sidebar" ) {
				const cartViewEvent = this.querySelector('[data-js-cart-view-event]');
				if ( cartViewEvent && typeof cartViewEvent.dispatchViewEvent === 'function' ) {
					cartViewEvent.dispatchViewEvent();
				}
				if ( document.querySelector('#cart-recommendations css-slider') ) {
					document.querySelector('#cart-recommendations css-slider').resetSlider();
				}
			}

		}

		hide(){

			this.opened = false;
			this.classList.remove('sidebar--opened');

			document.body.classList.remove('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			})

			document.querySelector(`[aria-controls="${this.id}"]`)?.setAttribute('aria-expanded', 'false');

			setTimeout(()=>{
				this.style.display = 'none';
			}, 501);

		}

	}


  if ( typeof customElements.get('sidebar-drawer') === 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( typeof MobileNavigation !== 'function' ) {
		
	class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;

			this.querySelectorAll('.has-submenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = true;
						this.classList.add('opened-first-submenu');
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this.#resizeContainer();
				})
			});

			this.querySelectorAll('.has-babymenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = true;
						this.classList.add('opened-second-submenu');
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this.#resizeContainer();
				})
			});

			this.querySelectorAll('.submenu-back a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = false;
						this.classList.remove('opened-second-submenu');
						this.#resizeContainer();
					} else if ( this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = false;
						this.classList.remove('opened-first-submenu');
						this.#resizeContainer(true);
					}
					this.closest('sidebar-drawer').scrollTo({top: 0});
					setTimeout(()=>{
						e.target.closest('li.opened').classList.remove('opened');
					}, 301);
					e.preventDefault();
				})
			});

			if ( this.dataset.showHeaderActions === 'true' ) {

				const headerActionsSource = document.querySelector('[data-js-header-actions]');
				if ( headerActionsSource ) {
					const mobileNavActions = document.createElement('div');
					mobileNavActions.classList = "header-actions flex-buttons";
					mobileNavActions.innerHTML = headerActionsSource.innerHTML;
					this.querySelector('nav').prepend(mobileNavActions);

				mobileNavActions.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-mobile`;
				});
				mobileNavActions.querySelectorAll('[data-modal]').forEach(elm=>{
					elm.addEventListener('keydown', e=>{
						if ( e.keyCode === window.KEYCODES.RETURN ) {
							window.lastFocusedElm = elm;
						}
					})
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					})
				});
				}

			}

		}

		#resizeContainer(main=false){
      if ( main ) {
				this.style.height = `auto`;
      } else {
				if ( this._openedSecondSubmenu ) {
					this.style.height = `${this.querySelector('.has-babymenu.opened .babymenu').scrollHeight}px`;
				} else if ( this._openedFirstSubmenu ) {
					this.style.height = `${this.querySelector('.has-submenu.opened .submenu').scrollHeight}px`;
				}  
      }
		}

	}

  if ( typeof customElements.get('mobile-navigation') === 'undefined' ) {
		customElements.define('mobile-navigation', MobileNavigation);
	}

}

if ( typeof ScrollableNavigation !== 'function' ) {

	class ScrollableNavigation extends HTMLElement {

		constructor() {

			super();

			this.linkList = this.querySelector('.link-list');
			this.header = this.parentNode;
			window.addEventListener('resize', debounce(()=>{
				this.#checkNav();
			}, 200));
			this.#checkNav();

			const rtl = document.documentElement.getAttribute('dir') === 'rtl';

			this.parentNode.querySelector('.scrollable-navigation-button--left').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft - (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})
			this.parentNode.querySelector('.scrollable-navigation-button--right').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft + (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})

		}

		#checkNav() {
			if ( this.linkList.scrollWidth > this.offsetWidth ) {
				this.header.classList.add('scrolling-navigation-enabled');
			} else {
				this.header.classList.remove('scrolling-navigation-enabled');
			}
		}
		
	}

  if ( typeof customElements.get('scrollable-navigation') === 'undefined' ) {
		customElements.define('scrollable-navigation', ScrollableNavigation);
	}

}